import { useState, useEffect, useCallback } from 'react';

const useFetchAllCompanies = ({ filters = {}, page = 1, limit = 10, searchTerm, type, orderBy }) => {
  const [companies, setCompanies] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCompanies, setTotalCompanies] = useState(0)
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastSearchTerm, setLastSearchTerm] = useState('');

  const fetchCompanies = useCallback(async () => {
    if (type === "home-search" && searchTerm === lastSearchTerm) {
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const queryParams = {
        ...filters, 
        q: searchTerm,
        page: page,
        limit: limit,
        ...(orderBy && { orderBy })
      };
      
      const query = new URLSearchParams(queryParams).toString();
      const url = `${process.env.REACT_APP_BACKEND_STAGING_URL}/api/companies?${query}`;
      
      const response = await fetch(url, {
        method: 'GET',
        credentials: 'omit', // Don't send cookies for public endpoint
        headers: {
          'Content-Type': 'application/json',
        }
      });
     
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch companies: ${response.status} - ${errorText}`);
      }

      const data = await response.json();
      
      // Response structure: { success: true, data: [...], totalPages, totalCompanies, currentPage }
      setCompanies(Array.isArray(data.data) ? data.data : []); 
      setTotalPages(data.totalPages || 1);
      setTotalCompanies(data.totalCompanies || 0);
      setLastSearchTerm(searchTerm);  
    } catch (error) {
      setError(error.message);
    } finally {
      setIsLoading(false);
    }
  }, [filters, searchTerm, page, limit, lastSearchTerm, orderBy]);  

  useEffect(() => {
    if (type === "company-search") {
      fetchCompanies();
    }
    
    // For home-search, only fetch if there's a search term
    if (searchTerm && type === "home-search") {
      fetchCompanies();
    }
  }, [filters, searchTerm, page, limit, type, fetchCompanies]);
  

  return { companies, totalPages, isLoading, error, totalCompanies, orderBy };
};

export default useFetchAllCompanies;


